import { AppUpdateToast } from '@gozoki/ui/components/app-update/app-update-toast'
import { materialTheme } from '@gozoki/ui/theme/material.theme'
import { ThemeProvider } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { router } from '~/router'
// Initialise l'API (URL, token callback, redirection 401) — import à effet de bord.
import '~/utils/api'
// Design system partagé + polices variables Gozoki.
import '@gozoki/ui/fonts'
import '~/index.css'

const queryClient = new QueryClient()

const rootElement = document.getElementById('root')
if (rootElement && !rootElement.innerHTML) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={materialTheme}>
          <RouterProvider router={router} />
          {/* Écran de boutique : rechargé de nuit s'il a une version de retard. Les toasts
              s'affichent dans le canvas du dashboard (Toaster de HomePage). */}
          <AppUpdateToast enabled={import.meta.env.PROD} reloadAtNight />
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}
